var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","color":"red","bottom":_vm.tooltipBottom,"left":_vm.tooltipLeft,"right":_vm.tooltipRight},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[(_vm.icon)?_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.iconColor},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }